// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const searchFormActions = require('client-v2/common/containers/search-form/actions')
const searchFormSelectors = require('client-v2/common/containers/search-form/selectors')
const articleActions = require('client-v2/common/models/article/actions')
const userActions = require('client-v2/common/models/user/actions')
const deferDispatch = require('client-v2/common/state/dispatch')
// Sibling imports
const AppHeader = require('./component-dumb')

function mapStateToProps(state) {
  return {
    hidden: state.env.nativeEmbedded,
    isSearchVisible: searchFormSelectors.isVisible(state),
    user: state.user.loggedIn ? state.user : null
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    // Common actions
    onSearchClick: dispatchAction(searchFormActions.show),
    // Logged-in actions
    onAddClick: dispatchAction(articleActions.showAddUrlModal),
    onProfileClick: dispatchAction(userActions.navigateToUserProfile),
    onSharedClick: dispatchAction(userActions.navigateToShared),
    // Logged-out actions
    onLoginClick: dispatchAction(authModalActions.showLogin),
    onSignupClick: dispatchAction(authModalActions.showSignup)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    AppHeader
  )
)
